var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fv-avatar",style:({width: _vm.size, height: _vm.size, fontSize: _vm.size})},[_c('div',{staticClass:"text",style:({lineHeight: _vm.size})},[_vm._v(_vm._s(_vm.text))]),(_vm.backgroundImage)?_c('div',{staticClass:"image",style:({backgroundImage: _vm.backgroundImage})}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/framevuerk-builder/node_modules/pug-html-loader/lib!./node_modules/framevuerk-builder/node_modules/vue-loader/lib??vue-loader-options!./src/components/fvAvatar.vue?vue&type=template&id=1f769c79&lang=pug&
// module id = 177
// module chunks = 0 1